import { render, staticRenderFns } from "./swiperAd.vue?vue&type=template&id=6460326d&scoped=true&"
import script from "./swiperAd.vue?vue&type=script&lang=js&"
export * from "./swiperAd.vue?vue&type=script&lang=js&"
import style0 from "./swiperAd.vue?vue&type=style&index=0&id=6460326d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6460326d",
  null
  
)

export default component.exports